
import { ILog } from "../../../../Lib/Log/types";
import { DEFAULT_DATABASE_NAME, DEFAULT_DATABASE_VERSION, DEFAULT_OPERATION_OBJECT_STORE_NAME, DEFAULT_TILE_OBJECT_STORE_NAME } from "../../../../ServiceWorker/TileCache/indexedDb/constants";
import { IIndexedDbTileOptions } from "./types";


/**
 * Class for a spatial-tile-cache that stores its data in the browsers IndexedDB
 */
export class IndexedDbTileInit {

    public static run = (options: IIndexedDbTileOptions, log: ILog): Promise<void> => {

        options.databaseName = options.databaseName || DEFAULT_DATABASE_NAME;
        options.operationObjectStoreName = options.operationObjectStoreName || DEFAULT_OPERATION_OBJECT_STORE_NAME;
        options.tileObjectStoreName = options.tileObjectStoreName || DEFAULT_TILE_OBJECT_STORE_NAME;

        // Create the store if it does not exist...
        return new Promise<void>((resolve, reject) => {

            //reject({ message: 'Test123' });

            const dbRequest: IDBOpenDBRequest = indexedDB.open(options.databaseName!, DEFAULT_DATABASE_VERSION);

            dbRequest.addEventListener("upgradeneeded", (dbEvent: any) => {
                const database: IDBDatabase = dbEvent.target.result;
                const upgradeTransaction: IDBTransaction = dbEvent.target.transaction;

                const opObjectStore = IndexedDbTileInit.createObjectStoreIfNotExists(database, upgradeTransaction, options.operationObjectStoreName!, { keyPath: "id"});
                IndexedDbTileInit.createIndexIfNotExists(opObjectStore, "idx_startedAt", "startedAt", { unique: false });
                IndexedDbTileInit.createIndexIfNotExists(opObjectStore, "idx_status", "status", { unique: false });

                IndexedDbTileInit.createObjectStoreIfNotExists(database, upgradeTransaction, options.tileObjectStoreName!, { keyPath: "url"});

                log.warning('indexedDB.upgradeneeded');
            });

            dbRequest.addEventListener("success", () => {
                log.info('indexedDB.open');
                resolve();
            })

            dbRequest.addEventListener("error", (event: any) => {
                log.error('indexedDB.open', event.target.error);
                reject(event.target.error);
            });

        });

    }

    private static createObjectStoreIfNotExists = (database: IDBDatabase, upgradeTransaction: IDBTransaction, name: string, creationOptions?: IDBObjectStoreParameters): IDBObjectStore => {
        if (database.objectStoreNames.contains(name))
            return upgradeTransaction.objectStore(name);
        else
            return database.createObjectStore(name, creationOptions);
    }

    private static createIndexIfNotExists = (objectStore: IDBObjectStore, name: string, creationKeyPath: string | Iterable<string>, creationOptions?: IDBIndexParameters): IDBIndex => {
        if (objectStore.indexNames.contains(name))
            return objectStore.index(name);
        else
            return objectStore.createIndex(name, creationKeyPath, creationOptions);
    }

}


